import React from 'react';
import { ShieldCheck } from 'lucide-react';
export function GuaranteeSection() {
  return <section className="py-20 bg-white px-4" data-id="element-78">
      <div className="max-w-4xl mx-auto space-y-12" data-id="element-79">
        {/* Pricing Block */}
        <div className="text-center mb-12" data-id="element-80">
          <div className="inline-block bg-[#FAF5EF] rounded-2xl p-8 border border-[#C4973B]/20 shadow-sm" data-id="element-81">
            <p className="text-gray-500 text-lg mb-2 line-through" data-id="element-82">
              Antes: $47
            </p>
            <p className="text-4xl font-bold text-[#C06B6B] mb-4" data-id="element-83">
              Hoy: $10.99
            </p>
            <p className="text-sm font-medium text-gray-600 uppercase tracking-wide" data-id="element-84">
              Pago único · Acceso inmediato
            </p>
          </div>
        </div>

        {/* Guarantee */}
        <div className="text-center max-w-2xl mx-auto" data-id="element-85">
          <ShieldCheck className="h-16 w-16 text-[#C06B6B] mx-auto mb-6" data-id="element-86" />
          <h2 className="text-3xl font-serif font-bold text-gray-900 mb-4" data-id="element-87">
            🛡️ Garantía de 7 días
          </h2>
          <p className="text-lg text-gray-600 mb-6" data-id="element-88">
            Si no sientes alivio físico real, no pagas nada.
            <br data-id="element-89" />
            Sin riesgo. Sin presión.
          </p>
        </div>

        {/* Metaphor */}
        <div className="bg-[#FDF8F4] p-8 md:p-12 rounded-3xl text-center" data-id="element-90">
          <h3 className="text-2xl font-serif font-bold text-gray-900 mb-6" data-id="element-91">
            🕊️ Imagina esto…
          </h3>
          <p className="text-lg text-gray-700 leading-relaxed mb-6" data-id="element-92">
            Tu cuerpo ha vivido como un animal enjaulado. Siempre alerta.
            Siempre esperando lo peor. Calma-5™ no lo obliga. No lo empuja.
          </p>
          <p className="text-xl font-medium text-[#C4973B]" data-id="element-93">
            👉 Solo le muestra que el peligro terminó.
            <br data-id="element-94" />Y que ya puede confiar otra vez.
          </p>
        </div>
      </div>
    </section>;
}